<template>
  <aside class="sidebar">
    <div class="sloganWrap" aria-hidden="true">
      <img class="sloganImg" :src="sloganImg" alt="" />
    </div>
    <nav>
      <el-menu
        class="menu"
        :default-active="activeIndex"
        :default-openeds="defaultOpeneds"
        :collapse="false"
        :router="false"
        @select="onSelect"
      >
        <template v-for="item in items">
          <el-submenu
            v-if="item.children && item.children.length"
            :key="`${item.name}__submenu`"
            :index="item.name"
          >
            <template slot="title">
              <i :class="item.iconClass" class="menuIcon" aria-hidden="true" />
              <span>{{ item.label }}</span>
            </template>

            <el-menu-item v-for="child in item.children" :key="child.name" :index="child.name">
              <i :class="child.iconClass" class="menuIcon" aria-hidden="true" />
              <span slot="title">{{ child.label }}</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item v-else :key="`${item.name}__item`" :index="item.name">
            <i :class="item.iconClass" class="menuIcon" aria-hidden="true" />
            <span slot="title">{{ item.label }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </nav>
  </aside>
</template>

<script>
import sloganImg from "@/assets/slogn.png";

export default {
  name: "InterviewerSidebar",
  props: {
    userName: { type: String, default: "王面试官" },
    department: { type: String, default: "前端技术部" },
    versionText: { type: String, default: "版本：原型 Preview" },
  },
  data() {
    return {
      sloganImg,
    };
  },
  computed: {
    allItems() {
      return [
        {
          name: "interviewer-dashboard-schedule",
          label: "面试安排",
          iconClass: "el-icon-date",
          path: "/interviewer/dashboard/schedule",
          code: "menu_schedule",
        },
        {
          name: "interviewer-dashboard-review",
          label: "面试复核",
          iconClass: "el-icon-document",
          path: "/interviewer/dashboard/review",
          code: "menu_review",
        },
        {
          name: "interviewer-dashboard-config-management",
          label: "配置管理",
          iconClass: "el-icon-setting",
          children: [
            {
              name: "interviewer-dashboard-interviewers",
              label: "面试官管理",
              iconClass: "el-icon-user",
              path: "/interviewer/dashboard/interviewers",
              code: "menu_interviewers",
            },
            {
              name: "interviewer-dashboard-hrs",
              label: "招聘HR管理",
              iconClass: "el-icon-phone-outline",
              path: "/interviewer/dashboard/hrs",
              code: "menu_hrs",
            },
            {
              name: "interviewer-dashboard-exception-behavior",
              label: "异常行为配置",
              iconClass: "el-icon-warning",
              path: "/interviewer/dashboard/exception-behavior",
              code: "menu_exceptionBehavior",
            },
          ],
        },
      ];
    },
    items() {
      const paths =
        (this.$store &&
          this.$store.state &&
          this.$store.state.privilege &&
          this.$store.state.privilege.menuPaths) ||
        [];

      if (!paths || !paths.length) return this.allItems;

      const filterTreeByPaths = (list) => {
        return (list || [])
          .map((it) => {
            if (it && it.children && it.children.length) {
              const children = filterTreeByPaths(it.children);
              if (!children.length) return null;
              return { ...it, children };
            }

            if (it && it.path && paths.includes(it.path)) return it;
            return null;
          })
          .filter(Boolean);
      };

      return filterTreeByPaths(this.allItems);
    },
    activeIndex() {
      return (this.$route && this.$route.name) || "";
    },
    defaultOpeneds() {
      const activeName = (this.$route && this.$route.name) || "";
      const config = (this.allItems || []).find((it) => it.name === "interviewer-dashboard-config-management");
      const childNames = (config && config.children ? config.children : []).map((c) => c.name);
      if (activeName && childNames.includes(activeName)) return ["interviewer-dashboard-config-management"];
      return [];
    },
  },
  methods: {
    onSelect(index) {
      if (!this.$router) return;
      if (this.$route && this.$route.name === index) return;
      this.$router.push({ name: index });
    },
  },
};
</script>

<style scoped>
.sidebar {
  border-right: 1px solid var(--line);
  background: #ffffff;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
}

.sloganWrap {
  width: 100%;
  padding: 4px 0 10px;
  display: flex;
  justify-content: center;
}

.sloganImg {
  width: 50%;
  height: auto;
  display: block;
  object-fit: contain;
}

.logoRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.logo {
  width: 90px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.logo img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

.brandTitle {
  font-size: 14px;
  font-weight: 900;
}

.me {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: var(--muted);
}

.avatar {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: radial-gradient(circle at 30% 20%, #fff, #4270f1);
}

nav {
  margin-top: 8px;
}

.navTitle {
  font-size: 11px;
  color: var(--muted);
  margin-bottom: 6px;
}

.menu {
  border-right: none;
  background: transparent;
}

.menuIcon {
  margin-right: 8px;
  font-size: 16px;
}

.sidebarFooter {
  margin-top: auto;
  font-size: 13px;
  color: var(--muted);
  padding-top: 6px;
}

.logout-btn {
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  color: var(--muted);
  font-size: 13px;
  height: 38px;
  line-height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.logout-btn:hover {
  color: #ef4444;
}
</style>

<style>
/* element-ui menu overrides inside sidebar */
.sidebar .el-menu-item {
  height: 38px;
  line-height: 38px;
  border-radius: 10px;
  margin: 4px 0;
  color: var(--muted);
}

.sidebar .el-submenu__title {
  height: 38px;
  line-height: 38px;
  border-radius: 10px;
  margin: 4px 0;
  color: var(--muted);
}

.sidebar .el-menu-item.is-active {
  background: var(--brand) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(66, 112, 241, 0.25);
}

.sidebar .el-menu-item:hover,
.sidebar .el-submenu__title:hover {
  background: #f8fafc;
}

.sidebar .el-menu-item.is-active:hover {
  background: var(--brand) !important;
}

.sidebar .el-menu-item i,
.sidebar .el-submenu__title i {
  color: inherit;
}
</style>

